import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Birthday Cruise Vilamoura · Private Yacht · Morningstar";
const DESC = "Celebrate your birthday in Vilamoura aboard Morningstar — private yacht for up to 18 guests, optional cake, DJ, saxophone and personalised décor. Sunset slots available.";
const PATH = "/birthday-cruise-vilamoura";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/birthday-cruise-vilamoura")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Birthday Cruise · Vilamoura · Algarve",
        title: "Birthday cruise in Vilamoura aboard ",
        titleAccent: "Morningstar.",
        sub: "Your own private yacht, your playlist, your guests — add a cake, a saxophonist, a DJ and a sunset. Up to 18 guests, fully crewed.",
        ctaPrimary: "View birthday cruises",
        ctaSecondary: "Plan my birthday",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "birthday cruise Vilamoura, birthday boat Vilamoura, birthday yacht Algarve, birthday party boat Vilamoura",
      altPath: { en: PATH, pt: "/pt/cruzeiro-aniversario-vilamoura" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Vilamoura Birthday Cruise",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Birthday Cruise Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});
